import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum ExportFormatId {
  PDF = 'pdf',
  XLS = 'xls',
}

export class ExportFormat extends Codebook<ExportFormatId> {
  static readonly PDF = new ExportFormat(ExportFormatId.PDF, () => $t('PDF'), 'file-pdf')
  static readonly XLS = new ExportFormat(ExportFormatId.XLS, () => $t('XLS'), 'file-xls')

  private constructor(
    id: ExportFormatId,
    public readonly name: () => string,
    public readonly icon: string,
  ) {
    super(id)
  }
}
